import React from "react";
import { arrayOf, any } from "prop-types";
import { FormSchemaFields } from "@stormwater-software/lib-form";
import { UIControlType } from "@stormwater-software/lib-form-control-types";

export function getInitialData(id) {
  return { 
    inspector_user_id: id,
    reassign_mode: "primary" // Default to primary inspector (existing behavior)
  };
}

function getSchema(users) {
  return {
    inspector_user_id: {
      label: "Inspector",
      controlType: UIControlType.select,
      options: users,
      placeholder: "Please select a user",
      noOptionMessage: "There are no users available.",
    },
    reassign_mode: {
      label: "Assignment Type",
      controlType: UIControlType.radio,
      options: [
        { 
          value: "primary", 
          label: "Primary inspector (all future inspections)"
        },
        { 
          value: "next_only", 
          label: "Next inspection only"
        }
      ],
      defaultValue: "primary"
    },
  };
}

function ReassignForm({ value, onChange, users }) {
  return (
    <>
      <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px', fontSize: '14px', color: '#555' }}>
        <strong>Assignment Type:</strong>
        <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
          <li><strong>Primary inspector:</strong> Updates the project's primary inspector. All current and future inspections will be assigned to this user.</li>
          <li><strong>Next inspection only:</strong> Only the next upcoming inspection will be assigned to this user. Subsequent inspections will continue using the project's primary inspector.</li>
        </ul>
      </div>
      <FormSchemaFields
        schema={getSchema(users)}
        formData={value}
        onChange={onChange}
      />
    </>
  );
}

ReassignForm.propTypes = {
  users: arrayOf(any).isRequired,
};

ReassignForm.defaultProps = {
  initialData: {},
};

export default ReassignForm;
